/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'l4-policy';
const componentName = 'l4-rule-port-match';
const prefix = `${moduleName}.${componentName}`;

export const portsLabel = `${prefix}.portsLabel`;
export const portsInputPlaceholder = `${prefix}.portsInputPlaceholder`;
export const portsHelperText = `${prefix}.portsHelperText`;

export const ENGLISH = {
    [portsLabel]: 'Ports',
    [portsInputPlaceholder]: 'Enter Ports',
    [portsHelperText]: 'Accepts single value, comma separate, and ranges',
};
